/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage
} from "../../../utils/methods";
import { getAllCompanies, saveChallengeData, createActivityChallengeV2 } from "../../../redux/actions/challengeActions";
import {
  getUserCompanyDetails,
  allowChallengeEventForSpouseDependent,
} from "../../../redux/actions/userProfileActions";
import { imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  Border,
  EditorContainer
} from "../../CreateEvent/style";
import StepsHeading from "../../RecogntionAdmin/corevalues/stepNames"; 
import { Main } from "../../AdminTeamCreation/styles";
import { getSurveyLibraries } from "../../../redux/actions";
import { closeIcon, UploadHDMIcon, RecognitionCloseIcon, AdminRightArrowIcon, AdminLeftArrowIcon } from '../../../utils/icons';
import {CustomInput, SurvivorAverage, SurvivorChallengeSection, TitleContainer} from './styles';
import moment from 'moment';
import { challengeTierPoints } from "../../../../mockData";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { FormHeading } from "../ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../../Manager/styles";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {CommonButtonPopup} from '../../ReportsV2/styles'
import {CommonButtonBorder} from '../../common/commonStyles'
import {RadioButtonWrapper, RadioButton} from '../../RecogntionAdmin/styles'
import { ProfileThemesAll } from '../../../redux/constants/apiConstants';
import { http } from '../../../redux/http';

class CreateActivityChallenge extends Component {
  constructor(props) {
    super();
    const { isGroupChallenge, isSurvivorChallenge } = props;
    let updatedTiers = challengeTierPoints;
    this.state = {
      step: 1,
      surveyArrow: false,
      activityArrow: false,
      challengeType: false,
      challengeTypeArrow:false,
      pointsArrow: false,
      buttonClickScrollTop: false,
      menuIsOpen: true,
      title: '',
      description: '',
      imageName: '',
      activityType: '',
      weeklyIncrement: null,
      survivorAverage: null,
      amigosToInvite: [],
      openDateTimePicker: '',
      imgSrc: '',
      activityChallengeType: '',
      activityChallengeValue:"",
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      imageUpdated: 0,
      challengePointKey: null,
      companiesPermission: false,
      locationPermission: false,
      selectedOption: 1,
      surveyId: '',
      surveyType: '',
      dailyGoal: 0,
      selectedDailyGoalOption: 1,
      is_team_challenge:0,
      challengePointValue: null,
      challengePoints: updatedTiers,
      buttonStatus: false,
      selectedChallengeType: null,
      selectedActivityType: null,
      selectedChallengePoint: '',
      selectedSurvey: null,
      so: false,
      charCount:0,
      getThemesValue:[],
      selectedTheme: null,
      themeId:null
    };
    this.onSelectPoints = this.onSelectPoints.bind(this);
  }

  componentDidMount() {
    this.props.getSurveyLibraries();
    this.getThemes()
  }

  getThemes = async () =>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${ProfileThemesAll}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        let data = [{ month_number: null, theme_text: 'None', month:"" }];
        this.setState({
          // getThemesValue:res.all_themes
          getThemesValue: data.concat(res.all_themes)
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  activityChallengeTypes = [
    {"key": "Classic challenge", "value": 'Classic challenge'},
    {"key": "Survivor challenge", "value": 'Survivor challenge'},
    {"key": "Charity Challenge", "value": 'Group Challenge'},
  ]

  activityTypesItems= [
    {"key": "Total Steps", "value": 'Total Steps', 'label':"Steps"},
    {"key": "Total Distance", "value": 'Total Distance', 'label':"Distance"},
    {"key": "Total Calories", "value": 'Total Calories', 'label':"Calories"}
  ]

  groupActivityTypesItems= [
    {"key": "Total Group Steps", "value": 'Total Group Steps', 'label':"Total group steps"},
    {"key": "Total Group Distance", "value": 'Total Group Distance', 'label':"Total group distance"},
    {"key": "Total Group Calories", "value": 'Total Group Calories', 'label':"Total group Calories"}
  ]

  stepsHeadingEvent = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2
    },
    {
      name: 'Create Challenge',
      showArrow: false,
      number: 3
    }
  ]; 

  onSubmit = () => {
    const { title, date, description, imgSrc, endDate, activityType, challengeMode, weeklyIncrement,
      survivorAverage, imageName, companies, challengeLength, survivorChallenge, groupChallenge, emailOption, surveyId, selectedOption, dailyGoal, selectedDailyGoalOption, is_team_challenge, teams, themeId, challengePointValue } = this.state;
    const { saveChallengeData, createActivityChallenge, createLibrary, editLibrary, history } = this.props;
    let survivorEndDate = moment(moment(date).add((challengeLength * 7) - 1, 'days')._d).format('MM/DD/YYYY');
    const challengeType = survivorChallenge ? 'survivor' : groupChallenge ? 'new_group' : 'group';
    this.setState({ buttonStatus: true });
    const challenge = {
      title,
      companies: companies,
      body: description,
      image: imgSrc,
      event_type: groupChallenge ? activityType === 'Total Group Steps' ? 'Total Steps' : activityType === 'Total Group Calories' ? 'Total Calories' : 'Total Distance' : activityType,
      end_date: createLibrary || editLibrary ? null : (survivorChallenge || groupChallenge) ? moment(survivorEndDate).format('YYYY-MM-DD') + ' ' + moment('11:59:59 PM', "hh:mm:ss a").format("HH:mm:ss") : moment(endDate).format('YYYY-MM-DD') + ' ' + moment('11:59:59 PM', "hh:mm:ss a").format("HH:mm:ss"),
      start_date: createLibrary || editLibrary ? null : moment(date).format('YYYY-MM-DD') + ' ' + moment('12:00:00 AM', "hh:mm:ss a").format("HH:mm:ss"),
      survivor_average: survivorAverage,
      weekly_increment: survivorChallenge ? weeklyIncrement : null,
      challenge_point: challengePointValue,
      challenge_mode: survivorChallenge ? challengeMode : '',
      challenge_type: challengeType,
      isSurvivorChallenge: survivorChallenge,
      isGroupChallenge: groupChallenge,
      ...emailOption,
      survey_id: selectedOption === 1 ? null : surveyId,
      daily_goal: selectedDailyGoalOption === 1 ? null : dailyGoal,
      is_team_challenge:is_team_challenge, 
      teams:teams,
      theme_month: themeId
    };
    saveChallengeData({ ...challenge, imageName });
    createLibrary && createActivityChallenge(challenge, history.location.pathname.includes("/company/challenges/")?'/company/challenges/categories':'/challenges/categories');
  };

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={() => window.history.back() }>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.t("Create Challenge")}
    </FormHeading>
  );

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeDescription = (e) => {
    const newContent = e.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };

  handleImageChange = (imgSrc) => {
    this.setState({ imgSrc });
  };

  handleRemoveImage = () => {
    this.setState({ imgSrc: "" });
  };

  onSelectPoints(name) {
    this.setState({
      selectedChallengePoint: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
    });
  }

  onChange = (e) => {
    let file = e.target.files[0];
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        const array = document.getElementById('create-challenge-file').value.split("\\");
        reader.onloadend = () => {
          this.setState({
            imgSrc: reader.result,
            imageName: array[array.length - 1],
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: baseImage,
                imageUpdated: this.props.editLibrary ? 1 : 0
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('create-challenge-file').value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('create-challenge-file').value = '';
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: '',
      imageName: '',
    });
  };

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      imgSrc,
      charCount
    } = this.state;
    const { t } = this.props;
    const maxLength = 3000;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeCreate"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter challenge title")}
                    name="title"
                    value={title}
                    maxLength="30"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/30 | C</div>
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Challenge image")}{<span className="imp">*</span>}<span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.handleImageChange}
                  onRemoveImage={this.handleRemoveImage}
                />
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />        
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("About the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <EditorContainer>
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      config={{
                        placeholder: 'Enter challenge description',
                        contentStyle: 'body { color: #184A61 !important; }'
                      }}
                      onReady={(editor) => {
                        this.editorInstance = editor;

                        const modelDocument = editor.model.document;

                        modelDocument.on('change:data', () => {
                          const data = editor.getData();
                          const plainText = data
                            .replace(/<[^>]*>/g, '')
                            .replace(/&nbsp;/g, ' ')
                            .trim();

                          const count = plainText.length;

                          if (count > maxLength) {
                            editor.execute('undo');
                            return;
                          }

                          this.setState({
                            description: data,
                            charCount: count,
                            disableButton: false,
                          });
                        });
                      }}
                    />

                  </EditorContainer>

                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  handleSelectChallengeType = (name) => {
    this.setState({
      activityChallengeType: name.value,
      survivorChallenge: name.value === "Survivor challenge",
      groupChallenge: name.value === "Group Challenge",
      activityType: name.value === "Group Challenge" ? "Total Group Steps" : "Total Steps",
      challengePointKey: this.state.challengePointKey,
      activityChallengeValue: name.key,
      selectedChallengeType:name.value,
    })
  };

  onSelectActivityChallenge = (name) => {
    this.setState({ 
      selectedActivityType: name.value,
      activityTypes:name.key,
      activityType:name.value });
  };

  onSelectPoint = (name, value, key ) => {
    this.setState({
      [name]: value,
      challengePointKey: key
    });
  };

  isNumberKey = (evt) => {
    let charCode = (evt.which) ? evt.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) evt.preventDefault();
  };

  handleActivityType = (name) => {
    this.setState({
      activityType: name
    })
  };

  handleActivityChallenge = (name) => {
    this.setState({
      selectedChallengeType: name
    })
  };

  stepTwoForm = () => {
    const {
      step,
      groupChallenge,
      activityType,
      survivorChallenge,
      survivorAverage,
      weeklyIncrement,
      selectedChallengeType,
      challengePointValue,
      challengePointKey,
      challengePoints,
      getThemesValue,
      selectedTheme
    } = this.state;
    const { t } = this.props;
    const activityTypes = groupChallenge ? this.groupActivityTypesItems : this.activityTypesItems;
    return (
      <Layout height="1000px">
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeCreate" />
            </div>
            <div className="form">
              <div className="formBody">
                <TitleContainer widthValue="70%" height="auto" padding="15px 0px 0px 0px">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={this.props.t("Challenge types")}
                    isRequired={true}
                    dropdownOpen={this.state.dropdownOpen}
                    placeholder={this.props.t("Select type")}
                    title={selectedChallengeType?.includes("Group") ? selectedChallengeType?.replace("Group", "Charity") : selectedChallengeType}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}
                    data={this.activityChallengeTypes}
                    onSelect={this.handleSelectChallengeType}
                    active={this.state.selectedChallengeType}
                    onSelectParameter={["activityChallengeType", "value", "key",]}
                    valueIndex={2}
                    itemValue={true}
                    labelMargin={"0px"}
                    dropIcon={true}
                    fontSize={"14px"}
                  />
                  <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                </TitleContainer>
                <TitleContainer widthValue="70%" height="auto" padding="0px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="0px" margin="0px">{this.props.t("Type of activity")}{<span className="imp">*</span>}</StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper isMargin="12px" width gap>
                      {activityTypes?.map((data,index)=>(
                        <div className="RadioButtonContainer" key={index}>
                          <RadioButton
                            type={"radio"}
                            checked={activityType === data.value}
                            onChange={() => this.onSelectActivityChallenge(data)}
                            id={data.label+1}
                            name="activityType"
                            value={data.key}
                          />
                          <div className="label">{data?.label}</div>              
                        </div>))}
                    </RadioButtonWrapper>
                  </div>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>
                </TitleContainer>    
               
                <SurvivorChallengeSection>
                  {survivorChallenge && (
                    <SurvivorAverage display="block" isMargin={"0px"} marginb="0px" isHeight={"48px"} width="49.5%">
                      <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{groupChallenge ? t('Team Goal') : t('Week one Goal')}{<span className="imp">*</span>}</StyledLabel>
                      <CustomInput
                        width="100%"
                        height={"48px"}
                        isFont={"rubik"}
                        isRadius={"4px"}
                        isBorder={"1px solid #BDBDBD"}
                        isBgColor={"white"}
                        type="number"
                        name="survivorAverage"
                        onChange={this.onChangeInput}
                        value={
                          activityType.includes("Distance")
                            ? parseFloat(survivorAverage)
                            : parseInt(survivorAverage,10)
                        }
                        pattern="[0-9]*"
                        min="0"
                        onKeyPress={(e) => this.isNumberKey(e)}
                        placeholder={
                          this.props.t("Enter aim/goal")
                        }
                      />
                      <div className="char-count">
                        <div className="count">{activityType.includes("Steps")?"(Example: 5000 steps)":activityType.includes("Calories")?"(Example: 5000 calories)":"(Example: 50 miles)"}</div>
                        <div className="count"></div>
                      </div>
                    </SurvivorAverage>
                    
                  )}
                
                  {survivorChallenge && (
                    <SurvivorAverage  display="block" isMargin={"0px"} marginb="0px" isHeight={"48px"} width="49.5%">
                      <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{t("Weekly increment")}{<span className="imp">*</span>}</StyledLabel>
                      <CustomInput
                        width="100%"
                        height={"48px"}
                        isFont={"rubik"}
                        isRadius={"4px"}
                        isBorder={"1px solid #BDBDBD"}
                        isBgColor={"white"}
                        type="number"
                        name="weeklyIncrement"
                        value={weeklyIncrement}
                        onChange={this.onChangeInput}
                        pattern="[0-9]*"
                        min="0"
                        onKeyPress={(e) => this.isNumberKey(e)}
                        placeholder={this.props.t("Enter increment")}
                      />
                    </SurvivorAverage>
                    
                  )}
                  {groupChallenge && (
                    <SurvivorAverage width="100%" isMargin={"0"} marginb="0" isHeight={"50px"}>
                      <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{t("Group goal")}{<span className="imp">*</span>}</StyledLabel>
                      <CustomInput
                        height={"48px"}
                        isRadius={"4px"}
                        isBorder={"1px solid #BDBDBD"}
                        isBgColor={"white"}
                        type="number"
                        name="survivorAverage"
                        onChange={this.onChangeInput}
                        value={
                          activityType.includes("Distance")
                            ? parseFloat(survivorAverage)
                            : parseInt(survivorAverage,10)
                        }
                        pattern="[0-9]*"
                        min="0"
                        onKeyPress={(e) => this.isNumberKey(e)}
                        placeholder={
                          activityType === "Total Steps" ||
                          activityType == "Total Group Steps"
                            ? this.props.t("Enter E.g. 500 Steps")
                            : activityType === "Total Calories" ||
                              activityType === "Total Group Calories"
                              ? this.props.t("Enter E.g. 30 Calories")
                              : this.props.t("Enter E.g. 25 Miles")
                        }
                      />
                      <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>
                    </SurvivorAverage>
                  )}
                </SurvivorChallengeSection>
                {survivorChallenge ? <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>: null}
                <TitleContainer widthValue="70%" height="275px" padding="0 0 8px 0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge point value")}
                    isRequired={true}
                    dropdownOpen={this.state.so}
                    placeholder={t("Select point value")}
                    title={challengePointKey}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={challengePoints}
                    onSelect={this.onSelectPoints}
                    active={challengePointValue}
                    onSelectParameter={["value", "key"]}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    t={t}
                    fontSize={"14px"}
                    dropIcon={true}
                  />
                </TitleContainer>
                <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px', display:"flex"}}/>
                <TitleContainer widthValue="70%" height="auto" padding="0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge month")}
                    isRequired={false}
                    dropdownOpen={this.state.so}
                    placeholder={t("Select month")}
                    title={selectedTheme}
                    id="dropdown-survey"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={getThemesValue}
                    onSelect={this.onSelectThemeType}
                    active={selectedTheme}
                    onSelectParameter={["theme_text", "month_number", "month"]}
                    itemValue={true}
                    valueIndex={2}
                    labelMargin={"0px"}
                    t={t}
                    dropIcon={true}
                    fontSize={"14px"}
                    showWrapText={0}
                  />
                </TitleContainer>
              </div> 
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value }, () => { });
  };

  onSelectSurveyType = (selectedItem) => {
    this.setState({
      selectedSurvey: selectedItem.survey_name,
      surveyType: selectedItem.survey_name,
      surveyId: selectedItem.id,
    });
  };

  onSelectThemeType = (selectedItem) => {
    this.setState({
      // selectedTheme: selectedItem.month+(selectedItem.month?" - ":"")+ selectedItem.theme_text,
      selectedTheme: selectedItem.month,
      themeId: selectedItem.month_number,
    });
  };

  stepThreeForm = () => {
    const {
      step,
      selectedOption,
    } = this.state;
    const {surveyLibraries, t} = this.props;
    const { selectedSurvey } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeCreate" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("Would you like to add the survey")} ?
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"Yes"}</div>              
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"No"}</div>              
                    </div>
                  </RadioButtonWrapper>
                </div>
                {selectedOption === 0 ?<Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>:null}
                {selectedOption === 0 ? (
                  <TitleContainer widthValue="70%" height="auto" padding="0">
                    <CommonDropdown
                      tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                      dropdownStyle={{ top: "90px" }}
                      labelText={t("List of surveys")}
                      isRequired={true}
                      dropdownOpen={this.state.so}
                      placeholder={t("Select survey")}
                      title={selectedSurvey}
                      id="dropdown-survey"
                      onClick={() => this.setState({ so: !this.state.so })}
                      data={surveyLibraries}
                      onSelect={this.onSelectSurveyType}
                      active={selectedSurvey}
                      onSelectParameter={["survey_name", "survey_name", "id"]}
                      itemValue={true}
                      valueIndex={0}
                      labelMargin={"0px"}
                      t={t}
                      dropIcon={true}
                      fontSize={"14px"}
                    />
                  </TitleContainer>
                ) : null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  DropdownIndicator = () => (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C12 10.3585 11.8559 10.7169 11.5684 10.9901L2.51663 19.5897C1.94083 20.1368 1.00725 20.1368 0.431681 19.5897C-0.143894 19.0429 -0.143894 18.1561 0.431681 17.609L8.44122 10L0.43196 2.39098C-0.143614 1.84394 -0.143614 0.957264 0.43196 0.410484C1.00753 -0.136826 1.94111 -0.136826 2.51691 0.410484L11.5687 9.00992C11.8563 9.28333 12 9.64172 12 10Z"
        fill="#0D4270"
      />
    </svg>
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true, buttonStatus:false });
  };

  render() {
    const { step, buttonStatus, title, imgSrc, description, activityType, activityChallengeType, survivorChallenge, groupChallenge, weeklyIncrement, survivorAverage,challengePointValue} = this.state;
    return (
      <React.Fragment>
        {step === 1?this.stepOneForm(): step === 2? this.stepTwoForm(): step === 3 && this.stepThreeForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description} onClick={!title||!imgSrc|| !description?null: () => this.updateStep(2)}>
                Next
                {!title||!imgSrc|| !description ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                {AdminLeftArrowIcon("#F37A65")}
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!activityType || !activityChallengeType || (survivorChallenge && (!weeklyIncrement || !survivorAverage)) || (groupChallenge && !survivorAverage) || (!challengePointValue && challengePointValue != 0)} onClick={!activityType || !activityChallengeType || (survivorChallenge && (!weeklyIncrement || !survivorAverage)) || (groupChallenge && !survivorAverage) || (!challengePointValue && challengePointValue != 0)?null: () => this.updateStep(3)}>
                Next
                {!activityType || !activityChallengeType || (survivorChallenge && (!weeklyIncrement || !survivorAverage)) || (groupChallenge && !survivorAverage) || (!challengePointValue && challengePointValue != 0) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : (
          step === 3 && (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(2)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={buttonStatus || (!this.state.selectedSurvey && this.state.selectedOption == 0)} onClick={!buttonStatus ? () => this.onSubmit():null}>
                  {this.props.t("Create Challenge")}
                  {buttonStatus || (!this.state.selectedSurvey && this.state.selectedOption == 0) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          )
        )}
      </React.Fragment>
    );
  }
}

CreateActivityChallenge.propTypes = {
  isSurvivorChallenge: PropTypes.bool.isRequired,
  createChallenge: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onHide: PropTypes.func,
  MandatoryFields: PropTypes.array.isRequired,
  survivorChallengeData: PropTypes.object,
  saveChallengeData: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchAllCompanies: PropTypes.func.isRequired,
  role: PropTypes.string,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  locationDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  isGroupChallenge: PropTypes.bool,
  activityChallengeById: PropTypes.bool,
  createActivityChallenge: PropTypes.func,
  createLibrary: PropTypes.bool,
  editChallengeLibrary: PropTypes.func,
  editLibrary: PropTypes.bool,
  userPermissions: PropTypes.array,
  surveyLibraries: PropTypes.array,
  getSurveyLibraries: PropTypes.func,
  t: PropTypes.func,
  fetchCompanyTeamUsers:PropTypes.func
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  userPermissions: state.profileData.userPermissions,
  surveyLibraries: state.surveys.surveyLibraries,
});

const mapDispatchToProps = (dispatch) => ({
  saveChallengeData: (data) => dispatch(saveChallengeData(data)),
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () => dispatch(allowChallengeEventForSpouseDependent),
  editChallengeLibrary: (challenge) => dispatch(editChallengeLibrary(challenge)),
  getSurveyLibraries: () => dispatch(getSurveyLibraries()),
  fetchCompanyTeamUsers: (companyId) => dispatch(fetchCompanyTeamUsers(companyId)),
  createActivityChallenge: (challenge, path) => dispatch(createActivityChallengeV2(challenge, path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CreateActivityChallenge));
